export default __webpack_public_path__ + "0a20c5b.png";